import React, { useEffect, useState } from "react";
import { Question } from "../types";
import { deleteSurveyQuestion } from "../Firebase/utils";
import { deleteQuestion } from "../store/features/CreateSurveySlice";
import { useAppDispatch, useAppSelector } from "../store/store";
import MultipleSelectionForm from "./MultipleSelectionForm";
import { TbArrowBadgeRightFilled } from "react-icons/tb";
import { FaCheckSquare } from "react-icons/fa";
import { updateQuestionResponse } from "../store/features/CompleteSurveySlice";

interface MultipleSelectionOptionsPreviewDisplayProps {
    question: Question;
    questionText: string;
    options: string[];
}

export default (props: MultipleSelectionOptionsPreviewDisplayProps) => {

    const { question, questionText, options } = props;
    const [ selectedOptions, setSelectedOptions ] = useState<string[]>([]);
    const dispatch = useAppDispatch();
    const user = useAppSelector(state => state.user.user);
    const survey = useAppSelector(state => state.survey.survey);
    const [ modalOpen, setModalOpen ] = useState<boolean>(false);
    
    useEffect(() => {
        dispatch(updateQuestionResponse({questionId:question.id, response:selectedOptions}))
    }, [selectedOptions]);

    const handleSelection = (option: string) => {
        if(selectedOptions.includes(option)){
            console.log('Removing Option: ', option);
            setSelectedOptions(selectedOptions.filter(selectedOption => selectedOption !== option));
        }else{
            console.log('Adding Option: ', option);
            setSelectedOptions([...selectedOptions, option]);
        }
    }

    return (
        <div className="flex flex-col w-11/12 p-1 rounded-md capitalize text-white">
            <h3 className="my-7 md:my-10 text-2xl md:text-4xl text-[#3da8e2]">{questionText}<span>
            <p className="text-white text-xl font-sans">(Select all that appy)</p></span></h3>
            <div className="flex flex-col gap-4">
            <ul className="flex flex-col gap-5">
                    {options.map((option: string) => {
                        return (
                            <button onClick={ () => {handleSelection(option)}} key={option} className={`grid grid-cols-12 md:flex gap-2 text-xl ${selectedOptions.includes(option) ? 'text-[#3da8e2]' : 'text-stone-500'}`}>
                                <FaCheckSquare className='col-span-1 text-3xl'/>
                                <p className='col-span-11 flex justify-start text-start pl-2'>{option}</p>
                            </button>
                        );
                    })}
                </ul>
            </div>
        </div>
    )
}